import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../../environments/environment';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { CommonService } from '../../common-service';
import { RemainingCreditsResponse } from '../../responses/platform/remaining-credits.response';

@Injectable({
    providedIn: 'root'
})
export class BookCreditsService extends CommonService {
    constructor(private http: HttpClient) {
        super();
    }

    public GetCredits(idBookVersion: number): Observable<RemainingCreditsResponse> {
        return this.http
            .get<RemainingCreditsResponse>(environment.urlApiPlatform + "BookReviewCredits/getRemaining/idBookVersion/" + idBookVersion, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }

    public UseCredits(idBookVersion: number): Observable<RemainingCreditsResponse> {
        return this.http
            .get<RemainingCreditsResponse>(environment.urlApiPlatform + "BookReviewCredits/use/idBookVersion/" + idBookVersion, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }
}
